export default __webpack_public_path__ + "static/media/Rectangle 137.7768fdcd.svg";